// extracted by mini-css-extract-plugin
export default {"buttons":"DevelopmentTab_buttons__ESwGx"};